export default {
	navigation: {
		individual: {
			label: '個人',
			menu_items: {
				online_shopping: 'オンラインショッピング',
				offline_kiosk: 'オフラインキオスク',
				pay_with_qr: 'QRコード決済',
				jpworldpay_creditcard: 'JP WORLD PAY クレジットカード',
				transaction_cashback: '取引とキャッシュバック',
				send_asset: '資産を送る',
				asset_request: '資産をリクエスト',
				get_deposit: '入金を受け取る',
				fee: '手数料',
				wallet: 'ウォレット',
				account: 'アカウント',
				jpys: 'JPYS追加',
				sell: '売却',
				exchanging_currency: '両替',
			},
		},
		business: {
			label: 'ビジネス',
		},
		development: {
			label: '開発',
		},
		customer_service: {
			label: 'カスタマーサービス',
		},
	},
	auth: {
		login: 'ログイン',
		signup: '新規登録',
	},
	accessibility: {
		toggle_navigation: 'ナビゲーションの切り替え',
		logo_alt: 'ロゴ',
		language_selector: {
			alt: '言語選択',
			current_language: '日本語',
		},
	},
};
